module.exports = __webpack_public_path__ + "assets/img/extra.d3464c56.png";